import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=2b3abe26&scoped=true"
import script from "./Locale.vue?vue&type=script&lang=js"
export * from "./Locale.vue?vue&type=script&lang=js"
import style0 from "./Locale.vue?vue&type=style&index=0&id=2b3abe26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3abe26",
  null
  
)

export default component.exports